import React, { useEffect, useState, MouseEventHandler } from 'react'

import { useOutletContext } from 'react-router-dom'

import Collections from '@components/music/Collections'
import OpenFilterButton from '@components/music/filter/OpenFilterButton'
import { usePageApi } from '@providers/PageApiProvider'
import { BrowsePageApiResponse } from '@providers/types/api-responses'

const BrowsePage: React.FC = () => {
  const { pageData } = usePageApi<BrowsePageApiResponse>()
  const [collections, setCollections] = useState(pageData?.collections ?? [])
  const { setSideFilterVisibility } =
    useOutletContext<{ setSideFilterVisibility: MouseEventHandler }>()

  useEffect(() => {
    if (pageData) {
      setCollections(pageData.collections)
    }
  }, [pageData])

  return (
    <div className="flex flex-col flex-1 h-full w-0" data-testid="browse-page">
      <div className="overflow-y-auto flex-1">
        <OpenFilterButton onClickFilter={setSideFilterVisibility} className="ml-4 mt-4" />
        <Collections collections={collections} />
      </div>
    </div>
  )
}

export default BrowsePage
